import { render, staticRenderFns } from "./CaseHT.vue?vue&type=template&id=38a7d567&scoped=true&"
import script from "./CaseHT.vue?vue&type=script&lang=js&"
export * from "./CaseHT.vue?vue&type=script&lang=js&"
import style0 from "./CaseHT.vue?vue&type=style&index=0&id=38a7d567&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a7d567",
  null
  
)

export default component.exports